export default __webpack_public_path__ + "static/media/outside.0f057680.png";